baseApp.service('ExportVpnUsersService', [function() {

    let exportVpnUsersService = {};

				exportVpnUsersService.exportToCsv = function (accountId, callback) {
								store.fetch({
												method: 'GET',
												path: "/exportVpnUsers?accountId=" + accountId,
																success: function success (data) {
																callback(data);
																if (data && data.redirectTo){
																				window.location = data.redirectTo + "&accountId=" + accountId;
																}
												},
								});
				}

    return exportVpnUsersService;
}]);
